let store = new Vuex.Store({
    state: {
        cart: {},
        available_vouchers: {},
        loaded: false,
        loading: true,
        message: {
            type: '',
            text: ''
        }
    },
    getters: {
        cart: state => state.cart,
        loaded: state => state.loaded,
        loading: state => state.loading,
        available_vouchers: state => state.available_vouchers,
    },
    actions: {
        getCart(store){
            axios
            .get("/ajax/cart")
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response)=>{
                store.state.cart = response.data
                store.state.loaded = true
            });
        },
        getAvailableVouchers(store){
            store.state.loading = true
            axios
            .get("/ajax/available-vouchers")
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response)=>{
                store.state.available_vouchers = response.data
                store.state.loading = false
            });
        },
        addProduct: (store, product) => {
            store.state.loading = true
            if (product.qty < 0) { product.qty = 1 }
            axios
            .post("/ajax/cart/add-product", {
                product: product,
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response) => {
                if (response.data.success == false) {
                    Vue.notify({text: response.data.message, type: 'error'})
                    if (response.data.cart) {
                        store.state.cart = response.data.cart
                    }
                } else {
                    if(response.data) {
                        // commit function to add to the store
                        store.state.cart = response.data
                        Vue.notify({text: window.t.cart.product_added, type: 'success'})
                    }
                }
                store.state.loading = false
            });
        },
        updateProduct: (store, product) => {
            store.state.loading = true
            // send ajax request to save in session
            axios
            .post("/ajax/cart/update-product", {
                product: product,
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'}) })
            .then((response) => {
                if (response.data.success == false) {
                    Vue.notify({text: response.data.message, type: 'error'})
                    if (response.data.cart) {
                        store.state.cart = response.data.cart
                    }
                } else {
                    // commit function to add to the store
                    store.state.cart = response.data
                }
                store.state.loading = false
            })
        },
        deleteProduct: (store, product) => {
            store.state.loading = true
            // send ajax request to save in session
            axios
            .post("/ajax/cart/delete-product", {
                product: product
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response) => {
                // commit function to add to the store
                store.state.cart = response.data
                store.state.loading = false
            })
        },
        applyVoucher(store, voucher){
            store.state.loading = true
            axios
            .post("/ajax/cart/apply-voucher", {
                voucher: voucher
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response)=>{
                if (response.data.cart) {
                    store.state.cart = response.data.cart
                    store.state.available_vouchers = response.data.available_vouchers
                }
                if (response.data) {
                    Vue.notify({
                        text: response.data.message,
                        type: response.data.success ? 'success' : 'error',
                        duration: 8000
                    })
                }
                store.state.loading = false
            });
        },
        deleteVoucher(store, voucher){
            store.state.loading = true
            axios
            .post("/ajax/cart/delete-voucher", {
                voucher: voucher
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response)=>{
                store.state.cart = response.data.cart
                store.state.available_vouchers = response.data.available_vouchers
                store.state.loading = false
            });
        },
    },
});

global.store = store

export default store
